import { useState } from "react";
import { Link } from "react-router-dom";
import api, { errText } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) { toast.error(errText(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#FAF8F5]">
      <div className="w-full max-w-sm eq-fade-up" data-testid="forgot-password-page">
        <div className="flex items-center gap-2 mb-8">
          <img src="/icon-192.png" alt="Equiro" className="h-11 w-11 rounded-xl object-cover" />
          <span className="font-display font-extrabold text-2xl text-[#1B3B2B]">Equiro</span>
        </div>

        {sent ? (
          <div data-testid="forgot-password-sent" className="text-center">
            <MailCheck className="h-12 w-12 text-[#1B3B2B] mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold text-[#1B3B2B]">Controlla la tua email</h1>
            <p className="text-[#5F6B64] mt-2">
              Se esiste un account con questo indirizzo, ti abbiamo inviato un link per reimpostare la password. Il link scade tra 1 ora.
            </p>
            <Link to="/login" className="inline-block mt-6 text-[#8C532B] font-semibold" data-testid="back-to-login">
              Torna all'accesso
            </Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-bold text-[#1B3B2B]">Password dimenticata</h1>
            <p className="text-[#5F6B64] mt-1 mb-8">Inserisci la tua email: ti invieremo un link per reimpostarla.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} data-testid="forgot-email"
                  onChange={(e) => setEmail(e.target.value)} placeholder="nome@esempio.it" className="mt-1.5" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full bg-[#1B3B2B] hover:bg-[#142E1F] h-11">
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Invia link
              </Button>
            </form>
            <p className="text-sm text-[#5F6B64] mt-6 text-center">
              <Link to="/login" className="text-[#8C532B] font-semibold" data-testid="back-to-login">Torna all'accesso</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
